export const getFileExtension = (fileName) => fileName?.split('.').at(-1);
